import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import { handleTableChange } from "../../../../utils/index";
import { connect } from "react-redux";

// import CrudOption from "components/dropdown/crudoption";
// import PopupButton from "components/button/PopupButton";
// import { 
// 	getTrainingClassList, 
// 	doTrainingClassDelete,
// 	doTrainingClassReset,
// } from "../../../../redux/trainingclass/trainingClassState";
// import SearchFilter from "components/search/SearchFilter";
// import { DATE_FORMAT, TIME_FORMAT_24HM, MODULE_TRAINING_CLASS } from "variables/constants";
// import dayjs from "dayjs";



const EmployeeProgressTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {


  	const columns = [
		{
	        title: `Employee`,
			width: '25%',


	        // dataIndex: 'tcl_title',
	        // key: 'tcl_title',
	        // render:(tcl_title) => <span>{tcl_title}</span> 
	    },
		{
			title: `Enrolled`,
			width: '15%',


			// key: 'tcl_schedule',  
			// render: (_, record) => (
			// 	<span>
			// 		{`${dayjs(record.tcl_schedule_date_from).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)} to ${dayjs(record.tcl_schedule_date_to).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)}`}
			// 	</span>
			// )
		},
		{
	        title: `Completed`,
			width: '15%',
			
	        // dataIndex: 'client_name',
	        // key: 'client_name',
	        // render:(client_name) => <span>{client_name}</span> 
	    },
		{
	        title: `Hours Spent`,
			width: '15%',	    
		},
		{
	        title: `Certificates`,
			width: '15%',	    
		},
		{
	        title: `Progess`,
			width: '15%',
		},
    ];
    
	// useEffect(() => {
	// 	doSearch({paginate: pagination.per_page});
	// }, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            // rowKey={(record) => record.tcl_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeProgressTable);
